import { getLanguages } from 'utils/languages'

export const EMAIL_FIELD = 'email'
export const NAME_FIELD = 'name'
export const PHONE_FIELD = 'phone'
export const LANGUAGE_FIELD = 'language'

export const getDefaultValues = languages => ({
  [NAME_FIELD]: '',
  [EMAIL_FIELD]: '',
  [PHONE_FIELD]: '',
  [LANGUAGE_FIELD]: getLanguages().filter(language =>
    languages.includes(language.value),
  )[0],
})
